/* eslint-disable */
/*
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 */
const debounce = (func, wait, immediate) => {
  let timeout
  return () => {
    const context = this
    const later = () => {
      timeout = null
      if (!immediate) {
        func.apply(context)
      }
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) {
      func.apply(context)
    }
  }
}

function getCookie(name) {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim()
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1)
    }
  }
  return null
}

const prettifyDate = date => {
  const locale = getCookie('locale')
  let prettifiedDate = new Date(date * 1000)
  let now = new Date()
  let now_timestamp = Date.now()
  let months, days, hours, minutes

  if (locale && locale === 'uk_UA') {
    months = ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру']
    days = 'д тому'
    hours = 'год тому'
    minutes = 'хв тому'
  } else if (locale && locale === 'ko_KR') {
    months = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
    days = '일 전'
    hours = '시간 전'
    minutes = '분 전'
  } else if (locale && locale === 'cs_CZ') {
    months = ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro']
    days = 'dny zpět'
    hours = 'hodin zpět'
    minutes = 'minut zpět'
  } else if (locale && locale === 'nl_NL') {
    months = ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
    days = 'd geleden'
    hours = 'u geleden'
    minutes = 'm geleden'
  } else if (locale && locale === 'fr_FR') {
    months = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc']
    days = 'j il y a'
    hours = 'h il y a'
    minutes = 'min il y a'
  } else if (locale && locale === 'de_DE') {
    months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    days = 'Tage her'
    hours = 'Std. her'
    minutes = 'Min. her'
  } else if (locale && locale === 'it_IT') {
    months = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
    days = 'g fa'
    hours = 'h fa'
    minutes = 'min fa'
  } else if (locale && locale === 'pl_PL') {
    months = ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru']
    days = 'd temu'
    hours = 'h temu'
    minutes = 'min temu'
  } else if (locale && locale === 'pt_PT') {
    months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    days = 'd atrás'
    hours = 'h atrás'
    minutes = 'min atrás'
  } else if (locale && locale === 'es_ES') {
    months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    days = 'd atrás'
    hours = 'h atrás'
    minutes = 'min atrás'
  } else if (locale && locale === 'sv_SE') {
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
    days = 'dagar sedan'
    hours = 'timmar sedan'
    minutes = 'minuter sedan'
  } else if (locale && locale === 'ru_RU') {
    months = ['Янв', 'Фев', 'Мар', 'Апр', 'Мая', 'Июня', 'Июля', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек']
    days = 'д назад'
    hours = 'ч назад'
    minutes = 'м назад'
  } else if (locale && locale === 'lt_LT') {
    months = ['Saus', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rgp', 'Rgs', 'Spa', 'Lap', 'Grd']
    days = 'd. prieš'
    hours = 'val. prieš'
    minutes = 'min. prieš'
  } else {
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    days = 'd ago'
    hours = 'h ago'
    minutes = 'm ago'
  }

  if (now.getMonth() !== prettifiedDate.getMonth() && now.getFullYear() === prettifiedDate.getFullYear()) {
    if ((now_timestamp - date * 1000) / 1000 / 60 / 60 / 24 <= 7 && (now_timestamp - date * 1000) / 1000 / 60 / 60 / 24 >= 1) {
      return `${Math.floor((now_timestamp - date * 1000) / 1000 / 60 / 60 / 24)}${days}`
    }
    if (locale && locale === 'uk_UA') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'ko_KR') return `${prettifiedDate.getMonth() + 1}월 ${prettifiedDate.getDate()}일`
    if (locale && locale === 'cs_CZ') return `${prettifiedDate.getDate()}. ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'nl_NL') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'fr_FR') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'de_DE') return `${prettifiedDate.getDate()}. ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'it_IT') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'pl_PL') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'pt_PT') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'es_ES') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'sv_SE') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'ru_RU') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'lt_LT') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    else return `${months[prettifiedDate.getMonth()]} ${prettifiedDate.getDate()}`
  }

  if (now.getFullYear() !== prettifiedDate.getFullYear()) {
    if (locale && locale === 'uk_UA')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}, ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'ko_KR')
      return `${prettifiedDate.getFullYear()}년 ${prettifiedDate.getMonth() + 1}월 ${prettifiedDate.getDate()}일`
    if (locale && locale === 'cs_CZ')
      return `${prettifiedDate.getDate()}. ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'nl_NL')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'fr_FR')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'de_DE')
      return `${prettifiedDate.getDate()}. ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'it_IT')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'pl_PL')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'pt_PT')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'es_ES')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'sv_SE')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]} ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'ru_RU')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}, ${prettifiedDate.getFullYear()}`
    if (locale && locale === 'lt_LT')
      return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}, ${prettifiedDate.getFullYear()}`
    else return `${months[prettifiedDate.getMonth()]} ${prettifiedDate.getDate()}, ${prettifiedDate.getFullYear()}`
  }

  if ((now_timestamp - date * 1000) / 1000 / 60 / 60 / 24 > 6) {
    if (locale && locale === 'uk_UA') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'ko_KR') return `${prettifiedDate.getMonth() + 1}월 ${prettifiedDate.getDate()}일`
    if (locale && locale === 'cs_CZ') return `${prettifiedDate.getDate()}. ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'nl_NL') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'fr_FR') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'de_DE') return `${prettifiedDate.getDate()}. ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'it_IT') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'pl_PL') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'pt_PT') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'es_ES') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'sv_SE') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'ru_RU') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    if (locale && locale === 'lt_LT') return `${prettifiedDate.getDate()} ${months[prettifiedDate.getMonth()]}`
    else return `${months[prettifiedDate.getMonth()]} ${prettifiedDate.getDate()}`
  }

  if ((now_timestamp - date * 1000) / 1000 / 60 / 60 / 24 <= 6 && (now_timestamp - date * 1000) / 1000 / 60 / 60 / 24 >= 1)
    return `${Math.floor((now_timestamp - date * 1000) / 1000 / 60 / 60 / 24)}${days}`

  if ((now_timestamp - date * 1000) / 1000 / 60 / 60 < 24 && (now_timestamp - date * 1000) / 1000 / 60 / 60 >= 1)
    return `${Math.floor((now_timestamp - date * 1000) / 1000 / 60 / 60)}${hours}`

  if ((now_timestamp - date * 1000) / 1000 / 60 < 60 && (now_timestamp - date * 1000) / 1000 / 60 >= 1)
    return `${Math.floor((now_timestamp - date * 1000) / 1000 / 60)}${minutes}`
  else
    return `${
      locale && locale === 'uk_UA'
        ? 'Тільки що'
        : locale && locale === 'ko_KR'
        ? '지금 막'
        : locale && locale === 'cs_CZ'
        ? 'Právě teď'
        : locale && locale === 'nl_NL'
        ? 'Zojuist'
        : locale && locale === 'fr_FR'
        ? "À l'instant"
        : locale && locale === 'de_DE'
        ? 'Gerade eben'
        : locale && locale === 'it_IT'
        ? 'Appena adesso'
        : locale && locale === 'pl_PL'
        ? 'Przed chwilą'
        : locale && locale === 'pt_PT'
        ? 'Agora mesmo'
        : locale && locale === 'es_ES'
        ? 'Justo ahora'
        : locale && locale === 'sv_SE'
        ? 'Just nu'
        : locale && locale === 'ru_RU'
        ? 'Только что'
        : locale && locale === 'lt_LT'
        ? 'Ką tik'
        : 'Just now'
    }`
}

const separateNumberByThousand = n => (n === null ? null : n > 0 ? n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0')

// Returns the length of the passed content. Accepts both string and object types.
const calculateContentLength = content =>
  content && content.length && typeof content === 'string'
    ? content.length
    : typeof content === 'object'
    ? JSON.stringify(content).length
    : 0

const copyTextToClipboard = text => {
  return navigator.clipboard.writeText(text)
}

// byKeys will return keys instead of values to the passed function
const mapObject = (obj, fn, byKeys = false) => {
  return Object.keys(obj).reduce((result, key) => {
    result[key] = byKeys ? fn(key) : fn(obj[key])
    return result
  }, {})
}

// Check if the app is launched in iframe
function isPreviewFrame() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

async function sleep(time = 0) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

function isPwaOpened() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone ||
    document.referrer.includes('android-app://')
  )
}

function getBrowserName() {
  let userAgent = navigator.userAgent
  let browserName
  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'chrome'
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'firefox'
  } else if (userAgent.match(/safari/i)) {
    browserName = 'safari'
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'opera'
  } else if (userAgent.match(/edg/i)) {
    browserName = 'edge'
  } else {
    browserName = null
  }
  return browserName
}

function getDeviceType() {
  let check = false
  // eslint-disable-next-line
  ;(function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check ? 'phone' : this.isTablet() ? 'tablet' : 'desktop'
}

function isTablet() {
  const userAgent = navigator.userAgent.toLowerCase()
  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
  return isTablet
}

function isIOS() {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

function safeZone(orientation) {
  switch (orientation) {
    case 'top':
      return getComputedStyle(document.documentElement).getPropertyValue('--sat')
    case 'right':
      return getComputedStyle(document.documentElement).getPropertyValue('--sar')
    case 'bottom':
      return getComputedStyle(document.documentElement).getPropertyValue('--sab')
    case 'left':
      return getComputedStyle(document.documentElement).getPropertyValue('--sal')
  }
}

function scrollTo(el) {
  if (el.scrollIntoView) return el.scrollIntoView({behavior: 'smooth'})
  if (el.$el && el.$el.scrollIntoView) return el.$el.scrollIntoView({behavior: 'smooth'})
  if (el[0]) {
    if (el[0].scrollIntoView) return el[0].scrollIntoView({behavior: 'smooth'})
    if (el[0].$el && el[0].$el.scrollIntoView) return el[0].$el.scrollIntoView({behavior: 'smooth'})
  }
}

function isOnLoginFlow(route) {
  return route.name.split('.').includes('auth')
}

function parseHtml(html, themeColor, trim = false, trimOn = 0) {
  let parser = new DOMParser()
  let _html = parser.parseFromString(html, 'text/html')
  let str = ''
  _html = [..._html.children[0].children[1].children]
  for (let i = 0; i < (_html.length > trimOn && trim ? trimOn : _html.length); i++) {
    _html[i].childNodes.forEach(child => {
      if (child && child.tagName && child.tagName == 'A') {
        const regExp = new RegExp(window.location.origin)
        if (regExp.test(child.attributes.href.value)) {
          child.removeAttribute('target')
          child.setAttribute('href', child.attributes.href.value.replace(regExp, ''))
        }
        child.style.color = themeColor

        child.style.textDecoration = 'underline'
      }

      if (child.children && child.children.length > 0) {
        for (let j = 0; j < child.children.length; j++) {
          if (child.children[j] && child.children[j].tagName && child.children[j].tagName == 'A') {
            const regExp = new RegExp(window.location.origin)
            if (regExp.test(child.children[j].attributes.href.value)) {
              child.removeAttribute('target')
              child.setAttribute('href', child.children[j].attributes.href.value.replace(regExp, ''))
            }
            child.children[j].style.color = themeColor

            child.children[j].style.textDecoration = 'underline'
          }
        }
      }
    })
  }
  if (trim) _html.splice(trimOn, _html.length)
  _html.forEach(el => {
    str += el.outerHTML
  })
  return str
}

function plainTextToHtmlWithLinks(text, color = false) {
  const addHttpsIfNeeded = link => {
    if (link && typeof link === 'string' && !link.startsWith('http://') && !link.startsWith('https://')) {
      return 'https://' + link
    }
    return link
  }

  const linkRegex = /^(https?:\/\/|www\.|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/

  let result = ''
  const lines = text.split('\n')

  for (let i = 0; i < lines.length; i++) {
    const words = lines[i].split(/(\s+)/) // сохраняем пробелы
    for (let word of words) {
      if (linkRegex.test(word)) {
        const fullHref = addHttpsIfNeeded(word)
        result += `<a href="${fullHref}" target="_blank" onpointerdown="event.stopPropagation()" ontouchstart="event.stopPropagation()" onclick="event.stopPropagation(), window.onALinkClick(event)" ontouchend="event.stopPropagation(), window.onALinkClick(event)" style="text-decoration: underline; ${
          color ? `color: ${getCorrectColor(color)};` : ''
        } word-break: break-all;">${word}</a>`
      } else {
        result += word
      }
    }
    if (i < lines.length - 1) {
      result += '<br>'
    }
  }

  return result
}

async function getLinesFromHtml(html, lineHeight = 20) {
  let parser = new DOMParser()
  let _html = parser.parseFromString(html, 'text/html')
  _html = [..._html.children[0].children[1].children]
  const height = await getNodeHeight(_html)
  return Math.floor(height / lineHeight)
}

function getNodeHeight(node, fontProps = 'font-size: 14px;line-height: 20px;font-weight: 400;') {
  return new Promise(resolve => {
    const div = document.createElement('div')
    const maxWidth = document.querySelector('#content').clientWidth - 32
    let height
    node.forEach(_node => {
      div.appendChild(_node)
    })
    // hide the meassured (cloned) element
    div.style.cssText = 'position:absolute; top:-9999px; opacity:0;' + fontProps
    // add the clone to the DOM
    document.body.appendChild(div)
    // meassure it
    div.style.maxWidth = maxWidth + 'px'
    setTimeout(() => {
      resolve(div.clientHeight)

      // cleaup
      div.parentNode.removeChild(div)
    }, 1000)
  })
}

function calcAspectRatio(ar) {
  return {'aspect-ratio': ar.replace(':', '/')}
}

function trimUrl(url) {
  let res = url.split('/')
  res.splice(3)
  res[1] = '//'
  res.push('/')
  return res.join('')
}

function scrollToTop() {
  document.querySelector('#content').scroll({
    top: 0,
    behavior: 'smooth'
  })
}

function disableScroll() {
  document.querySelector('#content').classList.replace('overflow-y-scroll', 'overflow-y-hidden')
}

function enableScroll() {
  document.querySelector('#content').classList.replace('overflow-y-hidden', 'overflow-y-scroll')
}

function prettifyTime(timestamp) {
  const timeFormat = getCookie('timeFormat')
  const date = new Date(timestamp * 1000)
  let hours = date.getHours()
  let minutes = date.getMinutes()
  minutes = minutes < 10 ? '0' + minutes : minutes
  if (timeFormat && timeFormat === '24H') {
    hours = hours < 10 ? '0' + hours : hours
    return `${hours}:${minutes}`
  }
  let ampm = hours >= 12 ? 'PM' : 'AM'
  hours %= 12
  hours = hours || 12
  return `${hours}:${minutes} ${ampm}`
}

function formatDate(timestamp) {
  const locale = getCookie('locale')
  const date = new Date(timestamp * 1000)
  const today = new Date()
  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth()
  const currentDay = today.getDate()
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  let months
  if (locale && locale === 'uk_UA') {
    months = ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру']
  } else if (locale && locale === 'ko_KR') {
    months = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
  } else if (locale && locale === 'cs_CZ') {
    months = ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro']
  } else if (locale && locale === 'nl_NL') {
    months = ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
  } else if (locale && locale === 'fr_FR') {
    months = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc']
  } else if (locale && locale === 'de_DE') {
    months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
  } else if (locale && locale === 'it_IT') {
    months = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
  } else if (locale && locale === 'pl_PL') {
    months = ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru']
  } else if (locale && locale === 'pt_PT') {
    months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
  } else if (locale && locale === 'es_ES') {
    months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  } else if (locale && locale === 'sv_SE') {
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
  } else if (locale && locale === 'ru_RU') {
    months = ['Янв', 'Фев', 'Мар', 'Апр', 'Мая', 'Июня', 'Июля', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек']
  } else if (locale && locale === 'lt_LT') {
    months = ['Saus', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rgp', 'Rgs', 'Spa', 'Lap', 'Grd']
  } else {
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }

  if (year === currentYear) {
    if (locale && locale === 'uk_UA') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'ko_KR') {
      return `${date.getMonth() + 1}월 ${day}일`
    } else if (locale && locale === 'cs_CZ') {
      return `${day}. ${months[date.getMonth()]}`
    } else if (locale && locale === 'nl_NL') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'fr_FR') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'de_DE') {
      return `${day}. ${months[date.getMonth()]}`
    } else if (locale && locale === 'it_IT') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'pl_PL') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'pt_PT') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'es_ES') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'sv_SE') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'ru_RU') {
      return `${day} ${months[date.getMonth()]}`
    } else if (locale && locale === 'lt_LT') {
      return `${day} ${months[date.getMonth()]}`
    } else {
      return `${months[date.getMonth()]} ${day}`
    }
  } else {
    if (locale && locale === 'uk_UA') {
      return `${day} ${months[date.getMonth()]}, ${year}`
    } else if (locale && locale === 'ko_KR') {
      return `${year}년 ${date.getMonth() + 1}월 ${day}일`
    } else if (locale && locale === 'cs_CZ') {
      return `${day}. ${months[date.getMonth()]} ${year}`
    } else if (locale && locale === 'nl_NL') {
      return `${day} ${months[date.getMonth()]}, ${year}`
    } else if (locale && locale === 'fr_FR') {
      return `${day} ${months[date.getMonth()]} ${year}`
    } else if (locale && locale === 'de_DE') {
      return `${day}. ${months[date.getMonth()]} ${year}`
    } else if (locale && locale === 'it_IT') {
      return `${day} ${months[date.getMonth()]}, ${year}`
    } else if (locale && locale === 'pl_PL') {
      return `${day} ${months[date.getMonth()]} ${year}`
    } else if (locale && locale === 'pt_PT') {
      return `${day} ${months[date.getMonth()]}, ${year}`
    } else if (locale && locale === 'es_ES') {
      return `${day} ${months[date.getMonth()]}, ${year}`
    } else if (locale && locale === 'sv_SE') {
      return `${day} ${months[date.getMonth()]} ${year}`
    } else if (locale && locale === 'ru_RU') {
      return `${day} ${months[date.getMonth()]}, ${year}`
    } else if (locale && locale === 'lt_LT') {
      return `${day} ${months[date.getMonth()]}, ${year}`
    } else {
      return `${months[date.getMonth()]} ${day}, ${year}`
    }
  }
}

function daysOfWeekLocaleArray() {
  const locale = getCookie('locale')
  let daysOfWeek = []
  if (locale && locale === 'uk_UA') {
    daysOfWeek = ['Пон', 'Вів', 'Сер', 'Чет', "П'ят", 'Суб', 'Нед']
  } else if (locale && locale === 'ko_KR') {
    daysOfWeek = ['월', '화', '수', '목', '금', '토', '일']
  } else if (locale && locale === 'cs_CZ') {
    daysOfWeek = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne']
  } else if (locale && locale === 'nl_NL') {
    daysOfWeek = ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo']
  } else if (locale && locale === 'fr_FR') {
    daysOfWeek = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim']
  } else if (locale && locale === 'de_DE') {
    daysOfWeek = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']
  } else if (locale && locale === 'it_IT') {
    daysOfWeek = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom']
  } else if (locale && locale === 'pl_PL') {
    daysOfWeek = ['Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob', 'Nie']
  } else if (locale && locale === 'pt_PT') {
    daysOfWeek = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']
  } else if (locale && locale === 'es_ES') {
    daysOfWeek = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']
  } else if (locale && locale === 'sv_SE') {
    daysOfWeek = ['Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör', 'Sön']
  } else if (locale && locale === 'ru_RU') {
    daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
  } else if (locale && locale === 'lt_LT') {
    daysOfWeek = ['Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št', 'Sk']
  } else {
    daysOfWeek = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
  }

  return daysOfWeek
}

function formatBytesString(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

function compressBase64Image(base64Image) {
  return new Promise(resolve => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const MAX_SIZE = 1600
      let width = img.width
      let height = img.height

      if (width > MAX_SIZE || height > MAX_SIZE) {
        const ratio = Math.min(MAX_SIZE / width, MAX_SIZE / height)
        width *= ratio
        height *= ratio

        canvas.width = width
        canvas.height = height

        ctx.drawImage(img, 0, 0, width, height)

        const compressedBase64Image = canvas.toDataURL('image/jpeg', 0.7)
        resolve(compressedBase64Image)
      } else {
        resolve(base64Image)
      }
    }

    img.src = base64Image
  })
}

function resetPageFocusedElement() {
  document.activeElement.blur()
}

function findLargestElementInArray(array) {
  if (array.length === 0) {
    return null // возвращаем null, если массив пуст
  }

  let largestElement = Number.NEGATIVE_INFINITY // инициализируем largestElement наименьшим возможным числом

  for (let i = 0; i < array.length; i++) {
    if (array[i] > largestElement) {
      largestElement = array[i] // обновляем largestElement, если находим больший элемент
    }
  }

  return largestElement
}

function findLargestElementInObject(obj) {
  let maxKey = null
  let maxValue = -Infinity

  for (let key in obj) {
    if (obj[key] > maxValue) {
      maxKey = key
      maxValue = obj[key]
    }
  }

  return {[maxKey]: maxValue}
}

function getPrioritizedBubbleFromMenuEntities(entities) {
  const overallPriority = {
    chats: 999,
    activity: 1
  }
  const entitiesPriority = {}

  for (let i = 0; i < entities.length; i++) {
    if (Object.keys(overallPriority).includes(entities[i].type) && entities[i].bubble.length > 0) {
      entitiesPriority[entities[i].type] = overallPriority[entities[i].type]
    }
  }

  return Object.keys(findLargestElementInObject(entitiesPriority))[0]
}

function getBubbleTypeFromMenuType(type) {
  const menuTypes = {
    chats: 'number',
    networking: 'number',
    activity: 'dot'
  }
  return menuTypes[type]
}

function getCorrectColor(color) {
  // Парсим цвет в RGB-компоненты
  let r,
    g,
    b,
    startingColor = color

  if (color.startsWith('#')) {
    // Если цвет задан в формате HEX (#RRGGBB)
    color = color.substring(1) // Удаляем символ #
    r = parseInt(color.substring(0, 2), 16)
    g = parseInt(color.substring(2, 4), 16)
    b = parseInt(color.substring(4, 6), 16)
  } else if (color.startsWith('rgb')) {
    // Если цвет задан в формате RGB или RGBA
    const rgbValues = color.match(/\d+/g) // Извлекаем числовые значения из строки
    r = parseInt(rgbValues[0], 10)
    g = parseInt(rgbValues[1], 10)
    b = parseInt(rgbValues[2], 10)
  } else {
    // Некорректный формат цвета
    throw new Error('Некорректный формат цвета')
  }

  // Вычисляем яркость по формуле
  // Яркость = (R * 299 + G * 587 + B * 114) / 1000
  const brightness = (r * 299 + g * 587 + b * 114) / 1000

  const theme = document.querySelector('meta[name="design-theme"]').content
  if (theme === 'light' || !theme) return brightness >= 175 ? '#1e1e1e' : startingColor
  if (theme === 'dark') return brightness <= 65 ? '#a1a1a1' : startingColor
}

function hexToRGB(hex) {
  color = hex.substring(1) // Удаляем символ #
  r = parseInt(color.substring(0, 2), 16)
  g = parseInt(color.substring(2, 4), 16)
  b = parseInt(color.substring(4, 6), 16)
  return {r, g, b}
}

function isColorBright(color, relateToTheme = true) {
  // Парсим цвет в RGB-компоненты
  let r, g, b

  if (color.startsWith('#')) {
    // Если цвет задан в формате HEX (#RRGGBB)
    color = color.substring(1) // Удаляем символ #
    r = parseInt(color.substring(0, 2), 16)
    g = parseInt(color.substring(2, 4), 16)
    b = parseInt(color.substring(4, 6), 16)
  } else if (color.startsWith('rgb')) {
    // Если цвет задан в формате RGB или RGBA
    const rgbValues = color.match(/\d+/g) // Извлекаем числовые значения из строки
    r = parseInt(rgbValues[0], 10)
    g = parseInt(rgbValues[1], 10)
    b = parseInt(rgbValues[2], 10)
  } else {
    // Некорректный формат цвета
    throw new Error('Некорректный формат цвета')
  }

  // Вычисляем яркость по формуле
  // Яркость = (R * 299 + G * 587 + B * 114) / 1000
  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  if (relateToTheme === false) return brightness >= 175

  const theme = document.querySelector('meta[name="design-theme"]').content
  if (theme === 'light' || !theme) return brightness >= 175
  if (theme === 'dark') return brightness <= 65
}

function getColorBrightness(color) {
  // Парсим цвет в RGB-компоненты
  let r, g, b

  if (color.startsWith('#')) {
    // Если цвет задан в формате HEX (#RRGGBB)
    color = color.substring(1) // Удаляем символ #
    r = parseInt(color.substring(0, 2), 16)
    g = parseInt(color.substring(2, 4), 16)
    b = parseInt(color.substring(4, 6), 16)
  } else if (color.startsWith('rgb')) {
    // Если цвет задан в формате RGB или RGBA
    const rgbValues = color.match(/\d+/g) // Извлекаем числовые значения из строки
    r = parseInt(rgbValues[0], 10)
    g = parseInt(rgbValues[1], 10)
    b = parseInt(rgbValues[2], 10)
  } else {
    // Некорректный формат цвета
    throw new Error('Некорректный формат цвета')
  }

  // Вычисляем яркость по формуле
  // Яркость = (R * 299 + G * 587 + B * 114) / 1000
  const brightness = (r * 299 + g * 587 + b * 114) / 1000

  return brightness
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

function parseDateFromTimestamp(timestamp) {
  const date = new Date(timestamp * 1000)

  const year = date.getFullYear()
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()

  return `${year}-${month}-${day}`
}

function parseTimeFromTimestamp(timestamp) {
  const date = new Date(timestamp * 1000)

  const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
  const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()

  return `${hours}:${minutes}:${seconds}`
}

function hasSameDomain(link) {
  const currentDomain = window.location.hostname

  const linkDomain =
    link.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+).*$/) &&
    link.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+).*$/)[1]

  return currentDomain === linkDomain
}

function stringToRgba(string, alpha) {
  let hash = 0
  let str = string.length <= 2 ? string.repeat(5) : string
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'
  for (let j = 0; j < 3; j++) {
    const value = (hash >> (j * 8)) & 255
    color += ('00' + value.toString(16)).substr(-2)
  }

  const r = parseInt(color.slice(1, 3), 16)
  const g = parseInt(color.slice(3, 5), 16)
  const b = parseInt(color.slice(5, 7), 16)

  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  const targetBrightness = 100

  if (brightness > targetBrightness) {
    const factor = targetBrightness / brightness
    const adjustedR = Math.floor(r * factor)
    const adjustedG = Math.floor(g * factor)
    const adjustedB = Math.floor(b * factor)
    return `rgba(${adjustedR}, ${adjustedG}, ${adjustedB}, ${alpha})`
  } else {
    const factor = targetBrightness / brightness
    const adjustedR = Math.min(255, Math.floor(r * factor))
    const adjustedG = Math.min(255, Math.floor(g * factor))
    const adjustedB = Math.min(255, Math.floor(b * factor))
    return `rgba(${adjustedR}, ${adjustedG}, ${adjustedB}, ${alpha})`
  }
}

function highlightLinksInEdjs(htmlString, color) {
  return htmlString.replace(/(<a\b[^>]*>.*?<\/a>)/g, function (match, p1) {
    return p1.replace(/(<a\b[^>]*)>/, '$1 style="color: ' + color + '; text-decoration: underline" target="_blank">')
  })
}

function handleCurrency(string, branded = true, color = null) {
  const is_before = getCookie('currency_before')
  let symbol = decodeURIComponent(getCookie('currency_symbol'))

  if (symbol === 'lightning-icon') {
    symbol = `<svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_8201_3679" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                  <rect width="16" height="16" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_8201_3679)">
                  <path d="M6.00014 9.99957H3.93348C3.66681 9.99957 3.46959 9.88013 3.34181 9.64124C3.21403 9.40235 3.22792 9.17179 3.38348 8.94957L8.36681 1.7829C8.47792 1.62735 8.62236 1.51901 8.80014 1.4579C8.97792 1.39679 9.16125 1.39957 9.35014 1.46624C9.53903 1.5329 9.67792 1.64957 9.76681 1.81624C9.8557 1.9829 9.88903 2.16068 9.86681 2.34957L9.33348 6.66624H11.9168C12.2057 6.66624 12.4085 6.79401 12.5251 7.04957C12.6418 7.30513 12.6057 7.54401 12.4168 7.76624L6.93348 14.3329C6.81125 14.4773 6.66125 14.5718 6.48348 14.6162C6.3057 14.6607 6.13348 14.644 5.96681 14.5662C5.80014 14.4885 5.66959 14.369 5.57514 14.2079C5.4807 14.0468 5.44459 13.8718 5.46681 13.6829L6.00014 9.99957Z" fill="${
                    branded && color ? color : 'currentColor'
                  }"/>
                </g>
              </svg>`
    return `<div style="display: inline-flex; align-items: center; text-decoration-line: inherit;">${
      +is_before ? symbol : ''
    }${string}${+is_before ? '' : symbol}</div>`
  }

  return `${+is_before ? (symbol.length > 1 ? symbol + ' ' : symbol) : ''}${string}${
    +is_before ? '' : symbol.length > 1 ? ' ' + symbol : symbol
  }`
}

// function that allows dynamic import for routes when updating app and adds several tries to fetch them
function retryDynamicImport(importFunction, retries = 3, delay = 1000) {
  return new Promise((resolve, reject) => {
    function attempt() {
      importFunction()
        .then(resolve)
        .catch(err => {
          if (retries > 0) {
            console.warn(`Retrying dynamic import... (${retries} attempts left)`)
            setTimeout(() => {
              retries--
              attempt()
            }, delay)
          } else {
            console.error('Dynamic import failed:', err)
            reject(err)
          }
        })
    }
    attempt()
  })
}

module.exports = {
  debounce,
  separateNumberByThousand,
  calculateContentLength,
  prettifyDate,
  copyTextToClipboard,
  mapObject,
  isPreviewFrame,
  sleep,
  calcAspectRatio,
  isPwaOpened,
  getBrowserName,
  getColorBrightness,
  getDeviceType,
  getNodeHeight,
  isTablet,
  isIOS,
  safeZone,
  scrollTo,
  isOnLoginFlow,
  parseHtml,
  plainTextToHtmlWithLinks,
  hexToRGB,
  trimUrl,
  stringToRgba,
  getLinesFromHtml,
  scrollToTop,
  disableScroll,
  enableScroll,
  hasSameDomain,
  prettifyTime,
  formatDate,
  formatBytesString,
  compressBase64Image,
  resetPageFocusedElement,
  findLargestElementInArray,
  findLargestElementInObject,
  getBubbleTypeFromMenuType,
  getPrioritizedBubbleFromMenuEntities,
  getCorrectColor,
  isColorBright,
  daysOfWeekLocaleArray,
  urlBase64ToUint8Array,
  parseDateFromTimestamp,
  parseTimeFromTimestamp,
  highlightLinksInEdjs,
  handleCurrency,
  retryDynamicImport
}
